import styled from "styled-components";
import { NewTypography } from "@bca/ui-library";
import theme from "../styles/theme";

export const Page = styled.div`
  min-height: 100vh;
  background-color: ${theme.color.LIGHT_GRAY};
  display: flex;
  flex-direction: column;
`;

export const StyledContainer = styled.div`
  background-color: ${theme.color.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${(props) =>
    props.isMobile === true
      ? "1.9735rem 0.75rem 1.25rem 0.75rem"
      : "5.5rem 5.875rem 2.25rem 5.875rem"};
  margin: ${(props) =>
    props.isMobile === true
      ? "2rem 0.625rem 1rem 0.625rem"
      : "3.375rem 20% 5.2rem 20%"};
  box-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  min-height: 57.5rem;
`;

export const StyledTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  margin-top: 2.188rem;
  margin-left: 0.5rem;
`;

export const StyledTypography = styled(NewTypography)``;

export const StyledA = styled.a`
  color: ${theme.color.ctaActionLink};
`;
